import client from "@irati/utils/services/apollo"
import authentication from "@irati/auth"

import {CelebrationTagKind, Occasion} from "@irati/types"
import getAllOccasions from "./queries/GetAllOccasions"
import getCelebrationTags from "./queries/CelebrationTags"
import createOccasion from "./mutations/CreateOccasion"
import updateOccasion from "./mutations/UpdateOccasion"

class OccasionsService {
  getAll() {
    const variables = {
      tenantId: authentication.business().uuid
    }
    return client.query({query: getAllOccasions, variables}).then((res) => res.data.occasions.results)
  }

  create(occasion: Occasion) {
    const variables = {
      occasion,
      tenantId: authentication.userTenant().uuid
    }
    return client.mutate({mutation: createOccasion, variables}).then((res) => {
      return res.data.createReward
    })
  }

  hide(occasion: Occasion) {
    const variables = {
      occasion: cleanOccasion(occasion),
      occasionId: occasion.uuid,
      tenantId: authentication.userTenant().uuid
    }
    variables.occasion.archived = true
    variables.occasion.createdAt = undefined
    return client.mutate({mutation: updateOccasion, variables})
  }

  show(occasion: Occasion) {
    const variables = {
      occasion: cleanOccasion(occasion),
      occasionId: occasion.uuid,
      tenantId: authentication.userTenant().uuid
    }
    variables.occasion.archived = false
    variables.occasion.createdAt = undefined
    return client.mutate({mutation: updateOccasion, variables})
  }

  update(occasion: Occasion, occasionId: string) {
    const variables = {
      occasion: cleanOccasion(occasion),
      occasionId,
      tenantId: authentication.userTenant().uuid
    }

    return client.mutate({mutation: updateOccasion, variables})
  }

  getCelebrationsTags(kind: CelebrationTagKind) {
    const variables = {
      kind
    }
    return client.query({query: getCelebrationTags, variables}).then((res) => res.data.celebrationTags)
  }
}

function cleanOccasion(occasionBase: Occasion) {
  const occasion = {...occasionBase}
  occasion.uuid = undefined
  occasion.default = undefined
  occasion.createdAt = undefined
  return occasionBase
}

export default new OccasionsService()
